<template>
  <div>
    <!-- requestTracking -->
    <div 
      class="card shadow m-3 position-fixed right-0 top-0 z-index-1 width-400 pb-3"
      data-card-name="requestTracking"
      data-test="card-progress-bar-tracking"
    >
      <div class="card-body d-flex align-items-center pb-2">
        <div 
          :class="{ 'rotate': !complete }"
          class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary width-and-height"
        >
          <i class="fa-solid fa-hourglass-half fa-2x" />
        </div>
        <div class="w-100">
          <div class="progress rounded-round mb-2 height-12">
            <div 
              class="progress-bar bg-primary rounded-round" 
              :style="`width:${progressBarWidth}%;`"
            >
              <!-- <span class="label-percent"></span> -->
            </div>
          </div>
          <div>
            <!-- กำลังสร้างหมายเลขแทรคกิ้ง 4 รายการจากทั้งหมด 50 รายการ -->
            <template v-if="fulfillmentName">
              {{ $t(`Sending shipment to`) }} {{ `${fulfillmentName}...` }}
            </template>
            <template v-else>
              {{ $t('Tracking code are being generated {countCreateTracking} out of {totalTracking}.') |
                replaceText((completeTrackingNum >= totalTracking ? totalTracking : completeTrackingNum), totalTracking) }}
            </template>
          </div>
        </div>
        <button 
          @click="generateTrackingCodeSuccess()" 
          type="button"
          class="close align-self-start ml-2 mr-n1 mt-n2"
        >
          <span>×</span>
        </button>
      </div>
      <div class="ml-3">
        <a 
          href="#collapse-requestTracking" 
          class="collapsed font-size-sm text-default" 
          data-toggle="collapse"
          ref="toggleCollapse"
          @click="() => wssMessages.length || shipmentList.length ? rotate = !rotate : {}"
        >
          <span class="text-primary">
            <ins>{{ $t('Response Message') }}</ins>
            <div class="header-elements d-inline-block">
              <div class="list-icons">
                <a
                  :class="['list-icons-item', {'rotate-180': rotate}]"
                  data-action="collapse"
                />
              </div>
            </div>
          </span> 
        </a>
      </div>
      <div 
        class="ml-4"
      >
        <div 
          class="collapse" 
          id="collapse-requestTracking"
        >
          <div 
            v-if="shipmentList.length > 0" 
            class="card-body card-body-log-error pl-0 pt-0 pb-0"
          >
            <transition-group 
              name="list" 
              tag="ul" 
              class="list mb-0 list-unstyled"
              data-test="list-transition-group"
            >
              <li 
                v-for="list in shipmentList" 
                :key="'list' + list.id" 
                class="font-size-sm my-2 border-bottom ml-1 py-1 list-item"
                :data-test="`transition-item-${list.id}`"
              >
                <div
                  class="text-515151 font-size-sm mb-1 ml-1"
                  style="font-weight: 400;"
                  :data-test="`transition-item-shipment-no-${list.id}`"
                >
                  {{ $t('Shipment No.') }}:
                  <a
                    v-if="list.integration_new && list.integration_new.code"
                    v-tooltip:top="(list.integration_new.type_name == 'Manually' ? 'Seller Own Fleet' : 'Standard Delivery') + ' / ' + (list.integration_new.name || list.integration_new.type_name)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    class="text-dark mx-1"
                    href="javascript:void(0)"
                  >
                    <img
                      :src="list.integration_new.logo"
                      width="30"
                      class="image_box"
                    >
                  </a>

                  <a
                    v-else-if="list.carrier_channel_code"
                    v-tooltip:top="(list.carrier_channel_type == 'Manually' || list.carrier_channel_type_name == 'Manually' ? 'Seller Own Fleet' : 'Standard Delivery') + ' / ' + (list.carrier_channel_name || list.carrier_channel)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    class="text-dark mx-1"
                    href="javascript:void(0)" 
                  >
                    <img
                      :src="list.carrier_channel_logo"
                      width="30"
                      class="image_box"
                    >
                  </a>
                
                  <a
                    v-else
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    class="text-dark mx-1"
                    href="javascript:void(0)" 
                  >
                    <img
                      :src="$storeIndex.getImageSrc('no-carrier')"
                      width="30"
                      class="image_box"
                    >``
                  </a>
                  {{ $t(list.shipment_number) }}
                </div>
                <div
                  class="text-515151 font-size-sm mb-1 ml-1"
                  style="font-weight: 400;"           
                  data-test="transition-item-shipment-no-load"
                >
                  {{ $t('Tracking No') }}:
                  <i class="fa-solid fa-spinner spinner ml-2" />
                </div>
                <div
                  class="font-size-sm mb-1 ml-1"
                  style="font-style: italic; color: #999; font-weight: 300;"
                  data-test="transition-item-requesting-tracking"
                >
                  {{ $t('Requesting tracking') }}
                </div>
              </li>
            </transition-group>
          </div>
          <div 
            v-if="wssMessages.length > 0" 
            class="card-body card-body-log-error pl-0 pt-0 pb-0"
          >
            <transition-group 
              name="list" 
              tag="ul" 
              class="list mb-0 list-unstyled"
              data-test="ws-transition-group"
            >
              <li 
                v-for="list in wssMessages" 
                :key="'list' + list.timestamp" 
                class="font-size-sm my-2 border-bottom ml-1 py-1 list-item"
                data-test="ws-item-transition-group"
              >
                <!-- <span :class="[list.status ? 'text-success':'text-danger']">
                  {{ $t(list.title) }} <template v-if="'attempts' in list && list.attempts > 0"> #{{ list.attempts }} </template> 
                </span> 
                <br>
                <span> {{ $t('Request ID') }}: {{ $t(list.requestId) }}</span>  <br>
                <span 
                  v-if="!list.status" 
                  class="text-two-lines"
                > 
                  {{ $t('Message') }}: {{ $t(list.message) }}
                </span> -->
                <div
                  class="text-515151 font-size-sm mb-1 ml-1"
                  style="font-weight: 400;"
                  :data-test="`ws-item-shipment-no-${list.shipmentId}`"
                > {{ $t('Shipment No') }}:
                
                  <a
                    v-if="list.carrier_channel_code"
                    v-tooltip:top="(list.carrier_channel_type == 'Manually' || list.carrier_channel_type_name == 'Manually' ? 'Seller Own Fleet' : 'Standard Delivery') + ' / ' + (list.carrier_channel_name || list.carrier_channel)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    class="text-dark mx-1"
                    href="javascript:void(0)"
                    data-test="ws-item-carrier-channel-logo"
                  >
                    <img
                      :src="list.carrier_channel_logo"
                      width="30"
                      class="image_box"
                    >
                  </a>
                  <a
                    v-else
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    class="text-dark mx-1"
                    href="javascript:void(0)"
                    data-test="ws-item-carrier-no-logo"
                  >
                    <img
                      :src="$storeIndex.getImageSrc('no-carrier')"
                      width="30"
                      class="image_box"
                    >
                  </a>
                  {{ $t(list.shipment_number || list.slug) }}
                </div>
                <!-- <span
                  style="font-weight: 400;"
                  :style="list.attempts == 5 || list.status ? 'color: #66BB6A;' : list.attempts == 5 || !list.status ? 'color: #F44336;' : 'color: #515151;'"
                > {{ $t('Tracking No') }}:
                  <i
                    v-if="list.attempts < 5 || !list.attempts"
                    class="fa-solid fa-spinner spinner ml-2"
                  />
                  <i
                    v-if="list.attempts == 5 || !list.status"
                    class="fa-solid fa-circle-exclamation mx-1"
                  />
                  <i
                    v-if="list.attempts == 5 || list.status"
                    class="fa-solid fa-circle-check mx-1"
                  />
                </span><br> -->
                <div
                  v-if="'attempts' in list && list.attempts > 0 && list.attempts < 5"
                  class="font-size-sm mb-1 ml-1"
                  style="font-weight: 400; color: #515151;"
                  :data-test="`ws-item-shipment-no-${list.shipmentId}`"
                >
                  {{ $t('Tracking No') }}:
                  <i
                    class="fa-solid fa-spinner spinner ml-2"
                  />
                </div>
                <div
                  v-else
                  class="font-size-sm mb-1 ml-1"
                  :class="[list.status ? 'text-success' : 'text-danger']"
                  :data-test="`ws-item-shipment-no-${list.shipmentId}`"
                >
                  <template> {{ $t('Tracking No') }}: </template>
                  <i
                    v-if="!list.status"
                    class="fa-solid fa-circle-exclamation mx-1"
                  />
                  <i
                    v-if="list.status"
                    class="fa-solid fa-circle-check mx-1"
                    data-test="item-icon-shipment-status"
                  />
                  <span :style="!list.status ? 'font-style: italic;' : ''">{{ $t(list.status ? list.title.replace("Tracking No: ", "") : list.title) }}</span>
                </div>
                <div
                  v-if="'attempts' in list && list.attempts > 0"
                  class="font-size-sm ml-1"
                  :class="'attempts' in list && list.attempts > 0 && list.attempts == 5 && !list.status ? 'mb-1' : ''"
                  style="font-style: italic; color: #F44336; font-weight: 300;"
                  data-test="ws-item-shipment-unsuccessful"
                >
                  {{ $t('Unsuccessful request for tracking') }} ({{ list.attempts }}/5)
                </div>
                <div
                  v-if="'attempts' in list && list.attempts > 0 && list.attempts == 5 && !list.status"
                  style="color: #999; font-weight: 300; overflow-y: auto;"
                  class="font-size-sm ml-1 mt-2"
                  data-test="ws-item-shipment-message"
                >
                  {{ $t(list.message) }}
                </div>
              </li>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/endpoint/tenant.service'
import WebSocket from "isomorphic-ws";
import Cookies from "js-cookie";
import { v4 as uuid } from 'uuid';
import eventBus from '@/plugins/eventBus';

export default {
  data() {
    const vm = this;
    return {
      totalTracking: 0,
      websocket: null,
      tenant: JSON.parse(Cookies.get('tenant')),
      user: JSON.parse(Cookies.get('user')),
      wssMessages: [],
      storageMessages : [],
      rotate : false, 
      fulfillmentName : null,
      alerted : true,
      timeOut : null,
      shipmentList: [],
      checkListReadyData: []
    }
  },
  computed: {
    progressBarWidth() {
      const completeTracking = this.wssMessages.filter(({done}) => done);

      return completeTracking.length * 100 / this.totalTracking;
    },
    checkListReady() {
      return this.$store.state.shipment.checkListReady;
    },
    complete() {

      const completeTracking = this.wssMessages.filter(({done}) => done);
      
      return this.totalTracking > 0 && completeTracking.length == this.totalTracking;
    },
    completeTrackingNum(){
      const completeTracking = this.wssMessages.filter(({done}) => done);
      return completeTracking.length;
    }
  },
  watch : {
    wssMessages(nVal, oVal) {
      // if(oVal.length == 0 && nVal.length > 0) {
      //   this.$refs.toggleCollapse.click();
      // }

      const findDuplicateIndex = this.shipmentList.findIndex(shipment => shipment.id == nVal[0].shipmentId);
      if (findDuplicateIndex > -1) {
        this.shipmentList.splice(findDuplicateIndex, 1);
      }
      const completeTracking = nVal.filter(({done}) => done);

      if(completeTracking.length == this.totalTracking && this.alerted) {
        const failed = nVal.filter(({status}) => !status).map(({shipmentId}) => shipmentId);

        const success =  nVal.filter(({status}) => status).map(({shipmentId}) => shipmentId);

        this.$store.dispatch("shipment/setInProgressShipment", {
          shipmentIds: failed,
          status: "cross",
        });

        this.$store.dispatch("shipment/setInProgressShipment", {
          shipmentIds: success,
          status: "checkmark",
        });

        this.alerted = false

        setTimeout(() => {
          if(failed.length == 0) {
            this.$store.dispatch("shipment/isModalGenTrackingCode", false)
          }

          this.$store.dispatch("shipment/updateShipmentDataTable", true)
        }, 2000)
      }
    },
    storageMessages(nVal, oVal) {
      let tmpArray = [];
      clearTimeout(this.timeout)
      if (this.storageMessages && this.storageMessages.length) {

        // console.log("this.checkListReady: ", this.$store.state.shipment.checkListReady);
        // console.log("storageMessages: ", this.storageMessages);
        // console.log("this.checkListReadyData: ", this.checkListReadyData);

        this.storageMessages.map(item => {
          const findMapArray = (this.checkListReadyData).find(shipment => shipment.id == item.shipmentId);
          if (findMapArray && findMapArray.id) {

            if(findMapArray.integration_new && findMapArray.integration_new.code) {
              tmpArray.push({
                ...item,
                carrier_channel_code: findMapArray.integration_new.code || findMapArray.carrier_channel_code,
                carrier_channel_type: findMapArray.integration_new.type_name || findMapArray.carrier_channel_type || findMapArray.carrier_channel_type_name,
                carrier_channel_name: findMapArray.integration_new.name || findMapArray.carrier_channel_name || findMapArray.carrier_channel,
                carrier_channel_logo: findMapArray.integration_new.logo || findMapArray.carrier_channel_logo,
              })
            } else {
              tmpArray.push({
                ...item,
                carrier_channel_code: findMapArray.carrier_channel_code,
                carrier_channel_type: findMapArray.carrier_channel_type || findMapArray.carrier_channel_type_name,
                carrier_channel_name: findMapArray.carrier_channel_name || findMapArray.carrier_channel,
                carrier_channel_logo: findMapArray.carrier_channel_logo,
              })
            }
            
          } else {
            tmpArray.push(item);
          }
        })

        // console.log("tmpArray: ", tmpArray);

      }

      // console.log("storageMessages: ", this.storageMessages);
      this.timeout = setTimeout(() =>   this.wssMessages = tmpArray , 333)
    },
    shipmentList() {
      // console.log("shipmentList: ", this.shipmentList);
    }
  },
  async created() {

    if (localStorage.getItem('isCypress')) {
        let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket'));
        if (dataWebsocket) {
          dataWebsocket.forEach(data => {
            let dataOnMessage = JSON.parse(JSON.stringify(data)) 
            this.webSocketOnMessage(dataOnMessage);
          }); 
        }
    }else{
    eventBus.on('requestTracking', payload => {
      this.webSocketOnMessage(payload);
      eventBus.off('requestTracking', payload)
    })
    }
  },
  methods: {
    webSocketOnMessage(payload = null){
      const isAlreadyExists = this.storageMessages.some(item => this.isEqual(item, payload, ['timestamp']));
      if (isAlreadyExists) return

      let done = true
      if(payload.status == true) {
        done = true
      } else {
        done = payload.attempts >= 5
      } 

      payload.done = done 
      this.storageMessages = this.updateOrCreateItemImmutable([...this.storageMessages], payload)
      const prefix = payload.slug.match(/[a-zA-Z]+/g).join('').toLowerCase()
      if(prefix === 'sm' && !payload.status && this.fulfillmentName && !this.sendToFulfillment) {
        this.totalTracking -= 1
      }
    },
    generateTrackingCodeSuccess() {
      this.$store.dispatch("shipment/updateShipmentDataTable", true);
      this.$store.dispatch("shipment/isModalGenTrackingCode", false);
    },

    async generateTrackingCodeFunc() {

      this.$store.dispatch('shipment/serviceAreaJson', []);
      this.$store.dispatch('shipment/slaSettingJson', []);
      this.$store.dispatch('shipment/tableRateJson', []);
      this.$store.dispatch('shipment/remoteAreaJson', []);
      this.$store.dispatch('shipment/tourismJson', []);

      let listshipmentReady = this.checkListReady.data;

      this.shipmentList = listshipmentReady;
      if (this.shipmentList.length) {
        this.rotate = true;
        this.$refs.toggleCollapse.click();
      }
      
      let fullFilmentCode = "";
      if (this.$store.state.shipment.isFulfillment && this.$store.state.user.feature.includes('feature-fulfillment')) {
        fullFilmentCode = this.$store.state.shipment.isFulfillment.code
        this.fulfillmentName = this.$store.state.shipment.isFulfillment.name
      }

      const tenantCooke = JSON.parse(Cookies.get('tenant'))

      const category = (tenantCooke && 'idt' in tenantCooke && tenantCooke.idt) ? tenantCooke.idt : 'General' 

      let param = listshipmentReady.map((shipment) => {

        this.checkListReadyData.push(shipment)

        if("mkp" in shipment) {
          return {
            id : shipment.id,
            mkp : true
          }
        }

        if (!shipment.trackingCode) {
          let totalWeight = 0;
          let totalQty = 0;
          let sku = [];
          let remark = [];
          let integrationNew = shipment.integration_new
          let products = [];

          let shipmentPackage = shipment.shipment_package
          totalWeight = shipment.product_total_weight ? parseFloat(shipment.product_total_weight) : 0;
          shipmentPackage.forEach(items => {
            let packageItems = items.package_items
            packageItems.forEach(rows => {
              // totalWeight += parseFloat(rows.product_weight * rows.ordered_quantity);
              totalQty += parseFloat(rows.ordered_quantity);
              sku.push(rows.sku);
              let productSku = rows.sku
              if(!productSku){
                productSku = rows.product_name
              }

              productSku = productSku.replace(/[`~^()|\=?;:'",<>\{\}\[\]\\\/]/gi, '');
              remark.push(`${productSku}(${Number(rows.ordered_quantity)})`);
              
              products.push({
                "code": rows.barcode,
                "name": rows.product_name,
                "category": category, 
                "detail": "-",
                "price": rows.price,
                "qty": rows.quantity,
                "size": "-",
                "color": "-",
                "weight": parseFloat(rows.product_weight),
                "length": "1",
                "width": "1",
                "height": "1"
              })

            });
          });
       
          // console.log('shipment.package_size => ', shipment.package_size);
          const obj = {
            extenal_id: uuid.v4(),
            shipment: {
              id: shipment.id,
              carrier_code: shipment.integration_new.code,
              carrier_name: shipment.integration_new.name,
              package_id: shipment.package_size.id,
              weight: totalWeight + parseFloat(shipment.package_size.weight),
              width: shipment.package_size.width,
              length: shipment.package_size.length,
              height: shipment.package_size.height,

              payment_method: shipment.shipment_package[0].sales_order[0].payment_method,
              cod_amount: shipment.shipment_package[0].sales_order[0].payment_method == 'COD' ? shipment.shipment_package[0].sales_order[0].total: 0,
              remark: remark.join(', ').substring(0, 250),
              total_qty: totalQty,
              cod_account_id: integrationNew.data.cod_account_id || '',
              sku: sku.join(', '),
            },
            order_number: shipment.shipment_package[0].sales_order[0].order_number,
            carrier: shipment.integration_new.type_id,
            integration_id: shipment.integration_new.id,
            fulfillment_code : fullFilmentCode && fullFilmentCode  in integrationNew.data.fulfillment_shipping_code ? integrationNew.data.fulfillment_shipping_code[fullFilmentCode] : null,
            ffm_external_id : `${this.tenant.id}-${shipment.id}`,
            sales_channel_code: shipment.shipment_package[0].sales_order[0].sales_channel_code,
            sender: {
              fullname: shipment.sender.fullname,
              address: shipment.sender.address1,
              county: shipment.sender.county,
              city: shipment.sender.city,
              state: shipment.sender.state,
              postcode: shipment.sender.postcode,
              mobile: shipment.sender.telephone1,
              mobile2: shipment.sender.telephone2,
              email: shipment.sender.email,
              cod_wallet: integrationNew.data.document.wallet_id || shipment.sender.telephone1,
              customer_code: integrationNew.data.document.customer_code || ''
            },
            recipient: {
              fullname: shipment.destination_fullname,
              address: shipment.destination_address1,
              county: shipment.destination_county,
              city: shipment.destination_city,
              state: shipment.destination_state,
              postcode: shipment.destination_postcode,
              mobile: shipment.destination_telephone1,
              mobile2: shipment.destination_telephone2,
              email: shipment.destination_email
            },
            products: products
          }
          if(shipment.pickup != null && shipment.pickup != undefined){
            let pickup = {
              pickup: {
                fullname: shipment.pickup.fullname,
                mobile: shipment.pickup.telephone1,
                city: shipment.pickup.city,
                state: shipment.pickup.state,
                county: shipment.pickup.country,
                address: shipment.pickup.address1,
                postcode: shipment.pickup.postcode
              },
            };
            Object.assign(obj, pickup)
          }
          if(shipment.integration_new.code === "INTER_EXPRESS") {
            obj['packages'] = [];
          }

          return obj
        }
      });

      this.totalTracking = param.length * (this.$store.state.shipment.isFulfillment ? 2 : 1);

      const isMkp = param.some(({mkp = false}) => mkp);

      if(isMkp) return;

      const chunkSize = 30;
      for (let i = 0; i < param.length; i += chunkSize) {
        let chunk = param.slice(i, i + chunkSize);

        let response = {
          status : 200,
          message : ""
        }

        try {
          let payloads = {
            client_id: this.$store.state.websocket.uuid,
            param: chunk
          }
          if (this.$store.state.shipment.isFulfillment && this.$store.state.user.feature.includes('feature-fulfillment')) {
            payloads.fulfillment_id = this.$store.state.shipment.isFulfillment.id
          }
          await Api.Shipment.postRequestTracking(payloads);
        } catch (err) {
          response = {
            status: err.response.status,
            message: err.response.message ? err.response.message : err.response.statusText
          }
        }
        if(response.status == 200) continue;

        const newShipmentList = this.$store.state.shipment.shipmentDataList.data.map(({loading, ...item}) => item)
        this.$store.dispatch("shipment/shipmentDataList", {...this.$store.state.shipment.shipmentDataList, data: newShipmentList});
        // this.$store.dispatch("shipment/checkListReady", {data : []});
        this.$store.dispatch("shipment/updateShipmentDataTable", false);
        this.$store.dispatch("shipment/isModalGenTrackingCode", false);

        if(response.status == 403) {
          if(response.message === "ERROR_FEATURE_NOT_ALLOWED") {
            this.$swal.fire({
              imageUrl: require('@/assets/global_assets/images/grongnoi_mee_x_me_akegasan.png'),
              imageWidth: 240,
              title: this.$t("Access Not Available") + "!",
              html: this.$t("Current plan is not support this feature.")+"<br/>"+this.$t("Please subscribe upper plan to access the feature."),
              showCancelButton: true,
              showConfirmButton: true,
              confirmButtonText: '<i class="fa-solid fa-envelope-open-dollar mr-2"></i>' + this.$t("Upgrade Now") + '!',
              buttonsStyling: false,
              cancelButtonText: '<i class="fa-solid fa-circle-check mr-2"></i>' + this.$t("Got It") + '!',
              reverseButtons: true,
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-primary",
              },
              showLoaderOnConfirm: true,
              preConfirm: () => this.$router.push({ path: '/app/premium-subscriptions'}),
            })
          } else {
            this.$swal.fire({
              imageUrl: require('@/assets/global_assets/images/grongnoi_mee_gunjae_mee_akegasan.png'),
              imageWidth: 240,
              title: this.$t('Access Denied') + "!",
              html: this.$t("You do not have permission to access this page.")+"<br/>"+this.$t("If you feel this is a mistake, contact your admin."),
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: '<i class="fa-solid fa-envelope-open-dollar mr-2"></i>' + this.$t("Got It") + '!',
              buttonsStyling: false,
              reverseButtons: true,
              customClass: {
                container: 'z-index-popup-tag',
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-primary",
              },
              showLoaderOnConfirm: true,
            })
          }
          break;
        }
      }
      this.$store.dispatch("shipment/setIsFulfillment", false);
    },
    updateOrCreateItemImmutable(array, newItem) {
      const index = array.findIndex(item => item.slug === newItem.slug);

      if (index !== -1) {
        // ถ้าพบ
        return array.map(
          item => (item.slug === newItem.slug) && !item.status
            ? { ...item, ...newItem } 
            : item 
          );
      }

      return [newItem, ...array];
    },
    isEqual(obj1, obj2, ignoreKeys = []) {
      if (obj1 === obj2) return true;
      if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
      const keys1 = Object.keys(obj1).filter(key => !ignoreKeys.includes(key));
      const keys2 = Object.keys(obj2).filter(key => !ignoreKeys.includes(key));


      if (keys1.length !== keys2.length) return false;
      for (let key of keys1) {
        if (!keys2.includes(key) || !this.isEqual(obj1[key], obj2[key], ignoreKeys)) return false;
      }

      return true;
    },
  },
  mounted() {
    this.generateTrackingCodeFunc();
  },
  beforeDestroy() {
    if (this.websocket) {
      this.websocket.close();
    }
  },
  filters: {
    replaceText: function (text, countCreateTracking, totalTracking) {
      text = text.replace('{totalTracking}', totalTracking);
      text = text.replace('{countCreateTracking}', countCreateTracking);
      return text;
    }
  },
}
</script>
<style scoped>
  .z-index-1 {
    z-index: 1;
  }
  .top-100 {
    top: 100px;
  }
  .width-and-height {
    width: 60px;
    height: 50px;
  }
  .width-400 {
    width: 400px;
  }
  .height-12 {
    height: 12px;
  }
  .card-body-log-error {
    max-height: 600px;
    overflow-x: hidden; 
    overflow-y: auto;
  }

  ul.list-unstyled {
    overflow: hidden;
  }

  ul.list-unstyled li.list-item {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #ddd;
    /* transition: all 0.5s ease; */
  }

  ul.list-unstyled li.list-item:last-child { 
    border-bottom: none !important; 
  }

  .list-enter-active, .list-leave-active {
    /* transition: all 0.5s ease; */
  }

  .list-enter, .list-leave-to /* .list-leave-active in versions <2.1.8 */ {
    opacity: 0;
    /* transform: translateX(10px); */
  }

  .text-two-lines {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/shipment/ModalGenTrackingCode.vue